// extracted by mini-css-extract-plugin
export default {"splash":"WelcomeSplash_splash__WTYPI","logo":"WelcomeSplash_logo__urZE2"};